/* @jsx h */
import { defineComponent, h, computed } from "vue";
import { TableStatus } from "@lemmonhq/types";
import { TableRow } from "./TableRow";
import { sortTables } from "@lemmonhq/orders";
import { useLocalization } from "@lemmonhq/uikit";
import { useAuth } from "@app/vue/providers/Auth";

export type TableGridProps = {
  tables: TableStatus[];
  onTablePayment: Function;
  onShowQR: (tableId: number) => void;
};
export const TablesGrid = defineComponent({
  name: "TablesGrid",
  props: ["tables", "onTablePayment", "onShowQR"],
  setup(props) {
    // Create a computed property to ensure reactivity
    const sortedTables = computed(() => sortTables(props.tables.value));
    const auth = useAuth();
    const { t } = useLocalization();
    return () => (
      <div class="overflow-x-auto h-full p-x2 lg:px-2 xl:px-4  rounded-md">
        {/* Desktop View */}
        <div class="hidden lg:block border rounded my-2">
          <table class="table table-zebra table-pin-rows ">
            <thead style="font-size: 16px;" class="text-1xl">
              <tr class="text-accent z-0">
                <th>
                  <span class="flex justify-start items-center">
                    {t("tables.core.table")}{" "}
                    <span class="material-symbols-outlined ml-1 text-2xl">
                      table_restaurant
                    </span>{" "}
                  </span>
                </th>
                <th class="hidden 2xl:block">
                  <span class="flex justify-start items-center">
                    {" "}
                    {t("tables.core.orders")}
                    <span class="material-symbols-outlined ml-1 text-2xl">
                      order_approve
                    </span>{" "}
                  </span>
                </th>
                <th>
                  <span class="flex justify-start items-center">
                    {" "}
                    {t("tables.core.duration")}
                    <span class="material-symbols-outlined ml-1 text-2xl">
                      history
                    </span>{" "}
                  </span>
                </th>
                <th>
                  <span class="flex justify-start items-center">
                    {auth.user.value?.restaurant.currency || "CHF"}
                    <span class="material-symbols-outlined ml-1 text-2xl">
                      payments
                    </span>{" "}
                  </span>
                </th>
                <th>
                  <span class="flex justify-start items-center">
                    {t("tables.core.status")}
                    <span class="material-symbols-outlined ml-1 text-2xl">
                      arrow_upload_progress
                    </span>{" "}
                  </span>
                </th>
                <th>
                  <span class="flex justify-start items-center">
                    {t("tables.core.notes")}
                    <span class="material-symbols-outlined ml-1 text-2xl">
                      notes
                    </span>{" "}
                  </span>
                </th>
                <th class="flex justify-end items-center text-right">
                  {t("tables.core.actions")}
                  <span class="material-symbols-outlined ml-1 text-2xl">
                    arrow_forward_ios
                  </span>{" "}
                </th>
              </tr>
            </thead>
            <tbody class="text-1xl">
              {sortedTables.value.map((table) => (
                <TableRow
                  key={table.table.id}
                  onTablePayment={props.onTablePayment}
                  tableStatus={table}
                  view="desktop"
                  onShowQR={props.onShowQR}
                />
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile View */}
        <div class="lg:hidden space-y-4 p-2">
          {sortedTables.value.map((table) => (
            <TableRow
              key={table.table.id}
              onTablePayment={props.onTablePayment}
              tableStatus={table}
              view="mobile"
              onShowQR={props.onShowQR}
            />
          ))}
        </div>
      </div>
    );
  },
});
